import { Component, OnInit } from '@angular/core';
import {HttpFilterService} from '../../services/http/http-filter.service';
import {Router} from '@angular/router';
import {FilterHandlerService} from '../../services/filter-handler.service';
import {debounce, debounceTime} from 'rxjs/operators';

@Component({
  selector: 'app-side-panel',
  templateUrl: './side-panel.component.html',
  styleUrls: ['./side-panel.component.scss']
})
export class SidePanelComponent implements OnInit {

  selects: {};
  filters: any;
  fullText: string;
  public showYearFilter: boolean;
  private intFilterAliases = ['stav_projektu', 'termin_realizace_do', 'oblast', 'rozpocet', 'mestska_cast']; //vlastně to jsou všechny aliasy

  trackByFn = (item) => {
    return item.id;
  };

  constructor(
      private router: Router,
      private httpFilter: HttpFilterService,
      private filterHandler: FilterHandlerService
  ) {
    this.filters = {};
    this.selects = {};
  }

  ngOnInit() {
    this.filterHandler.onSystemFilterChange().pipe(debounceTime(500)).subscribe( (filters) => {
      this.selects = filters;
      this.intFilterAliases.forEach( (item, index) => {
        if (this.filters[item] && index !== 1) {
          const valArr: Array<any> = this.filters[item].map( (i) => i.id );
          this.filters[item] = [];
          valArr.forEach( (fil) => {
            this.filters[item].push(this.selects[item].options.filter( opt => opt.id === fil)[0]);
          });
        }
      });
    });
    this.onFilterChange(); /** Výchozí filtr, existuje vždy */

    this.filterHandler.onPopulateSignal().subscribe( (signal) => {
      this.populateFilter(signal);
    });
  }

  /** Přesměrování outletu */

  filterList() {
    this.filterHandler.updateSelectedFilters(this.filters);
    this.router.navigate(['vypis']);
    this.filterHandler.sendReloadDataSignal();
  }


  filterGraph() {
    this.filterHandler.updateSelectedFilters(this.filters);
    this.router.navigate(['statistiky']);
    this.filterHandler.sendReloadDataSignal();
  }

  onProjectStateChange() {
    if (this.filters.stav_projektu) {
      this.showYearFilter = !!this.filters.stav_projektu.find(item => item.id === 6); // Magická konstanta, 6 je index Int tabulky
      if (!this.showYearFilter) { // Tohle mohlo jít asi do ifu už nahoru
        delete(this.filters[this.intFilterAliases[1]]);
      }
    }
  }

  onFilterChange() {
    this.filterHandler.updateSelectedFilters(this.filters);
    this.intFilterAliases.forEach( (item, index) => {
      this.filterHandler.getNextSelectOptions(item, index);
    });
  }

  onFullText() {
    this.filterHandler.setFullText(this.fullText);
    this.router.navigate(['vypis']);
    this.fullText = '';
  }

  private populateFilter(signal: any) {
    this.filters[signal.filterKey] = [this.selects[signal.filterKey].options.find(item => item.id === signal.optionId)];
  }
}
